module.exports = __webpack_public_path__ + "static/media/apache-solr.677c2ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/apache-solr.png
// module id = 495
// module chunks = 0